import { SearchInterface, KendraConst } from "@amzn/ask-legal-domain";
import { Multiselect, MultiselectProps } from "@amzn/awsui-components-react";
import * as React from "react";
import { UIModel } from "../../../model/ui-model";
import { getStringFilterValues, replaceStringListFilter } from "./search-filter-utils-v2";

const AUTHORS = KendraConst.ContainerIngestionKendraAttributes.Default.Authors;

export const AuthorFilterV2 = (props: {
    authors: string[];
    queryInputState: UIModel.State<SearchInterface.SearchQueryInput>;
    disabled?: boolean;
}) => {
    const options = React.useMemo<MultiselectProps.Option[]>(
        () => props.authors.map(a => ({ label: a, value: a })),
        [props.authors]
    );
    const selectedValues = getStringFilterValues(props.queryInputState.value, AUTHORS);
    const selectedOptions = selectedValues.map(v => options.find(o => o.value === v) || { label: v, value: v });

    return (
        <Multiselect
            inlineLabelText="Authors"
            placeholder="All"
            filteringType="auto"
            inlineTokens
            selectedOptions={selectedOptions}
            options={options}
            disabled={props.disabled}
            onChange={({ detail }) => props.queryInputState.setValue(replaceStringListFilter(
                props.queryInputState.value,
                AUTHORS,
                detail.selectedOptions.map(o => o.value).filter((v): v is string => !!v)
            ))}
        />
    );
};
